module.exports = __webpack_public_path__ + "assets/img/68e6bce14259ffa8a368f878dca26ace.png";